"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminUserComponent = void 0;
const core_1 = require("@angular/core");
//INTERNAL BITS
const permission_service_1 = require("./permission.service");
//VARIABLE MODELS
const user_1 = require("./user");
const role_1 = require("./role");
let AdminUserComponent = class AdminUserComponent {
    constructor(_permission) {
        this._permission = _permission;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // Load the permissions
            this.permission = this._permission.get();
            // Load user roles
            this.roles = yield role_1.Role.list({ type: 'user' });
            // Load users
            this.users = yield user_1.User.find();
        });
    }
    onUserCreated() {
        return __awaiter(this, void 0, void 0, function* () {
            // Load users
            this.users = yield user_1.User.find();
        });
    }
};
exports.AdminUserComponent = AdminUserComponent;
exports.AdminUserComponent = AdminUserComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-user',
        templateUrl: 'app/admin-user.component.html',
        styleUrls: ['styles/admin.component.css']
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [permission_service_1.PermissionService])
], AdminUserComponent);
//# sourceMappingURL=admin-user.component.js.map